import { debounce } from "lodash";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { CustomInput } from "shared/components/allInput";
import CustomBatch from "shared/components/CustomBatch";
import TableContainer from "shared/Tables/TableContainer";
import { GetContractListAction } from "store/actions/ContractActions";
import { getStatus } from "utils/common";
import { Button } from "primereact/button";
import CustomOverlay from "shared/components/CustomOverlay";

export default function ContractListing() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [contract, setContract] = useState([]);
  const [count, setCount] = useState(0);
  const [globalFilter, setGlobalFilter] = useState("");
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const page = query.get("page") || 1;
  const rows = query.get("rows") || 10;
  const [first, setFirst] = useState(0);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [isSearch, setIsSearch] = useState("");

  useMemo(() => {
    setFirst(page * rows - rows);
  }, []);

  //  useEffect(() => {
  //   // Check if path contains an ID (24-character hex string)
  //   const pathParts = window.location.hash.split('/');
  //   const lastPart = pathParts[pathParts.length - 1];
    
  //   if (/^[0-9a-f]{24}$/i.test(lastPart)) {
  //     // Reconstruct URL without ID
  //     const cleanPath = pathParts.slice(0, -1).join('/');
  //     window.history.replaceState({}, '', cleanPath);
  //   }
  // }, []);

  const filterContracts = (event) => {
    const value = event.target.value;
    setGlobalFilter(value);
  };

  const header = (
    <div className="flex justify-content-between align-items-center">
      <div className="flex align-items-center gap-3 mb-2">
        <h4 className="m-0">Contracts</h4>
      </div>
      <CustomInput
        name="search"
        value={search}
        onChange={({ value }) => {
          setFirst(0);
          setSearch(value);
          debouncedOnChange.current(rows, 1, value);    
        }}
        isSearch={isSearch}
        placeholder="Search"
        ignoreLabel
        col={4}
        searchIcon
      />
    </div>
  );

  const handleSearch = (rows, page, search) => {
    setIsSearch(true);
    getContractsList(rows, page, search);
  };

  const debouncedOnChange = useRef(debounce(handleSearch, 1000));

  const columns = useMemo(() => [
    {
      name: "Agreement",
      accessor: "agreementType",
      value: true,
    },
    {
      name: "Agreement Name",
      accessor: "agreementName",
      value: true,
    },
  ]);

  useMemo(() => {
    setFirst(page * rows - rows);
  }, []);

 
  useEffect(() => {
    getContractsList(rows, page, "");
  }, []);

  const getContractsList = (rows, page, search) => {
    dispatch(
      GetContractListAction(
        rows,
        page,
        search,
        setIsSearch,
        dispatch,
        (res) => {
          setContract(res?.list);
          setCount(res?.count);
          navigate(`/contracts?page=${page}&rows=${rows}`);
        }
      )
    );
  };

  const onPageChange = (e) => {
    getContractsList(e.rows, e.page + 1, "");
    setFirst(e.first);
  };

  const viewActions = (d) => {
    return (
      <CustomOverlay extraClass={"text-center"}>
        <ul className="no-style p-0">
          <li
            className="flex gap-2 text-xs font-medium mb-3 cursor-pointer"
            onClick={() => navigate(`/contract-generator/${d?._id}`)}
          >
            <i className="pi pi-pen-to-square cursor-pointer text-dark"></i>
            Edit
          </li>
          <li
            className="flex gap-2 text-xs font-medium mb-3 cursor-pointer"
            onClick={() =>
              navigate(`/contract-generator/${d?._id}`, {
                state: { activeTab: 1 },
              })
            }
          >
            <i className="pi pi-eye text-dark"></i> View
          </li>
        </ul>
      </CustomOverlay>
    );
  };

  return (
    <div>
      <div className="mb-2">
        {" "}
        <Button
          icon="pi pi-arrow-left"
          label="Back"
          onClick={() => navigate("/contract-generator")}
          className="p-button-text"
        />
      </div>
      <TableContainer
        customActions={viewActions}
        list={contract}
        columns={columns}
        header={header}
        count={count}
        first={first}
        rows={rows}
        outOf={rows * page > count ? count : rows * page}
        onPageChange={onPageChange}
      />
    </div>
  );
}
